import { Container } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    bg: {
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'left',
        padding: '1rem .5rem 2rem 0.5rem',
        [theme.breakpoints.up('md')]: {
            padding: '4rem 0',
        },
    },
    contentContainer: {
        borderBottom: `1px solid #dfdfdf`,
        paddingBottom: '1rem',
    },
    textContainer: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'left',
        marginBottom: '1rem',
    },
    title: {
        fontWeight: '700',
        fontSize: '1.6rem',
        [theme.breakpoints.up('md')]: {
            fontSize: '2rem',
        },
    },
    p: {
        [theme.breakpoints.up('md')]: {
            fontSize: '1.1rem',
        },
    },
}))

const Hero = () => {
    const classes = useStyles()

    return (
        <>
            <div className={classes.bg}>
                <Container>
                    <div className={classes.contentContainer}>
                        <h1 className={classes.title}>
                            Is Gift Card Granny Legit?
                        </h1>
                        <div className={classes.textContainer}>
                            <p className={classes.p}>
                                <strong>
                                    At Gift Card Granny, we know security is a
                                    top priority.
                                </strong>{' '}
                                Entering financial information online can be
                                nerve-wracking, especially on a new site. We
                                understand there might be mixed reviews out
                                there. That's why we want to be transparent.
                                Gift Card Granny is a reputable company with a
                                proven track record. Learn more about why you
                                can shop with confidence at Gift Card Granny.
                            </p>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    )
}

export default Hero
